import banners, { BannerTypes } from '@gin-betting/banners';
import core from '@gin-betting/core';

import UserDevice from 'services/user-device';
import { GetBannerZones } from './types';

const {
    entities: {
        constants: { GET_SPORTS_SUCCESS },
    },
    utils: { getSportTypeFromLocation },
} = core;

const {
    actions: { getAvailableBannerZones },
} = banners;

export const getBannerZones: GetBannerZones = actions$ => {
    return actions$.ofType(GET_SPORTS_SUCCESS).map(() => {
        const platform = UserDevice.getInstance()?.isDeviceMobile()
            ? BannerTypes.BannerZonePlatform.MOBILE
            : BannerTypes.BannerZonePlatform.DESKTOP;

        const sportType = getSportTypeFromLocation();

        return getAvailableBannerZones({
            pageType: sportType,
            platform,
        });
    });
};
